import { notifications } from '@/api/endpoints'
import { notificationMap } from './model'

const fetchNotifications = (consultantId, page, perPage) => {
  return new Promise((resolve) => {
    const params = {
      page,
      per_page: perPage
    }

    notifications.getAll({ consultantId }, { params })
      .then(response => {
        if (response.data.success) {
          var notifications = response.data.response

          const data = {
            totalNotifications: notifications.total,
            unRead: notifications.total_unread,
            notifications: []
          }

          for (var i = 0; i < notifications.data.length; i++) {
            data.notifications.push(notificationMap(notifications.data[i]))
          }

          resolve({
            success: true,
            data: data
          })
        } else {
          resolve({
            success: false
          })
        }
      })
      .catch(() => {
        resolve({
          success: false
        })
      })
  })
}
const subscribeUser = (consultantId, payload) => {
  return new Promise((resolve) => {
    notifications.subscribe({ consultantId, payload })
      .then(response => {
        if (response.data.success) {
          resolve({
            success: true
          })
        } else {
          resolve({
            success: false
          })
        }
      })
      .catch(() => {
        resolve({
          success: false
        })
      })
  })
}
const unSubscribe = (consultantId, payload) => {
  return new Promise((resolve) => {
    notifications.unsubscribe({ consultantId, payload })
      .then(response => {
        if (response.data.success) {
          resolve({
            success: true,
            data: response.data.response
          })
        } else {
          resolve({
            success: false
          })
        }
      })
      .catch(() => {
        resolve({
          success: false
        })
      })
  })
}

const getRedirectionUrl = (consultantId, notificationId) => {
  return new Promise((resolve) => {
    notifications.redirect({ consultantId, notificationId })
      .then(response => {
        if (response.data.success) {
          let data = response.data.response.data
          resolve({
            success: true,
            data
          })
        } else {
          resolve({
            success: false
          })
        }
      })
      .catch(() => {
        resolve({
          success: false
        })
      })
  })
}

export default {
  fetchNotifications,
  subscribeUser,
  unSubscribe,
  getRedirectionUrl
}
